import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';
import App from './App.tsx';
import { ErrorBoundary } from '@sentry/react';
import { IS_SENTRY_DISABLED, SENTRY_DSN } from '@config/config.ts';
import { initSentry } from './libs/sentry.tsx';
import { initPostHog } from './libs/posthog.ts';
import { capturePromoterCode } from '@utils/promoterCode';
import { captureUtmParams } from '@utils/utmParams';
import AppCrashFallback from '@components/AppCrashFallback';

const isSentryDisabled = IS_SENTRY_DISABLED?.toLowerCase() === 'true';
initSentry(SENTRY_DSN, isSentryDisabled);

initPostHog();
capturePromoterCode();
captureUtmParams();

// Render the app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {!isSentryDisabled ? (
      <ErrorBoundary fallback={<AppCrashFallback />}>
        <App />
      </ErrorBoundary>
    ) : (
      <App />
    )}
  </StrictMode>,
);
